import React, { useState, useEffect } from 'react';
import Slider from 'react-slick';

const Slideshow = () => {
    const [slideImages, setSlideImages] = useState([]);
    const [loading, setLoading] = useState(true);

    // Fetch slider data from the server
    useEffect(() => {
        const fetchSliderImages = async () => {
            try {
                const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/sliders`);
                const data = await response.json();
                // Filter active slides
                const activeSlides = data.filter(slide => slide.status === 'active');
                setSlideImages(activeSlides);
            } catch (error) {
                console.error('Error fetching slider images:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchSliderImages();
    }, []);

    const sliderSettings = {
        dots: true, // Show navigation dots
        infinite: true, // Infinite looping
        speed: 500, // Transition speed
        autoplay: true, // Enable auto sliding
        autoplaySpeed: 3000, // Slide every 3 seconds
        slidesToShow: 1, // Show one slide at a time
        slidesToScroll: 1, // Scroll one slide at a time
    };

    return (
        <div className="w-full h-full">
            {loading ? (
                <div className="bg-slate-400 animate-pulse max-md:h-[240px] md:h-full">
                </div>
            ) : (
                <Slider {...sliderSettings} className='h-full w-full'>
                    {slideImages.map((slide) => (
                        <div key={slide.id} className='h-full w-full'>
                            <div className="relative h-full w-full">
                                {slide.image ? (
                                    // If image exists, render it
                                    <img
                                        className="w-full max-md:h-[240px] md:h-full object-cover rounded-lg"
                                        src={slide.image}
                                        alt={slide.title}
                                    />
                                ) : slide.image_url ? (
                                    // If image_url exists, render it (online video)
                                    <video
                                        className="w-full max-md:h-[240px] object-cover rounded-lg"
                                        controls
                                    >
                                        <source src={slide.image_url} type="video/mp4" />
                                    </video>
                                ) : null}
                            </div>
                        </div>
                    ))}
                </Slider>
            )}
        </div>
    );
};

export default Slideshow;
